"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Overlay = exports.Content = exports.Container = exports.CloseButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Overlay = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  opacity: 0.5;\n"])));
exports.Overlay = Overlay;
var Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999999999999999;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n  background-color: ", ";\n"])), function (_ref) {
  var fullPage = _ref.fullPage;
  return fullPage ? 'black' : 'transparent';
});
exports.Container = Container;
var Title = _styledComponents.default.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: bold;\n"])));
exports.Title = Title;
var CloseButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  opacity: 1;\n  background: #606061;\n  line-height: 25px;\n  position: absolute;\n  right: -12px;\n  text-align: center;\n  top: -10px;\n  text-decoration: none;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n  -moz-box-shadow: 1px 1px 3px #000;\n  -webkit-box-shadow: 1px 1px 3px #000;\n  box-shadow: 1px 1px 3px #000;\n  display: flex;\n  justify-content: center;\n  width: 25px;\n  height: 25px;\n  align-items: center;\n  border: none;\n  &:hover {\n    background: #805e59;\n  }\n"])));
exports.CloseButton = CloseButton;
var Content = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  z-index: 99999;\n  background: ", ";\n  position: relative;\n  padding: ", ";\n  height: 100%;\n  margin: ", ";\n  max-width: ", ";\n  border-radius: ", ";\n"])), function (_ref2) {
  var background = _ref2.background;
  return background || 'transparent';
}, function (_ref3) {
  var fullPage = _ref3.fullPage;
  return fullPage ? 0 : '1rem';
}, function (_ref4) {
  var fullPage = _ref4.fullPage;
  return fullPage ? 'initial' : 'auto';
}, function (_ref5) {
  var fullPage = _ref5.fullPage;
  return fullPage ? 'initial' : '500px';
}, function (_ref6) {
  var fullPage = _ref6.fullPage;
  return fullPage ? 'initial' : '3px';
});
exports.Content = Content;